import * as types from '../actions/actionTypes';
import { newMapWith, updateableReducer } from './common';
import initialState from './initialState';

const backupLocationsReducer = (actionType) => {
    switch (actionType) {
        case types.BACKUP_LOCATIONS_UPDATED:
            return (stateValue, actionValue) => new Map(actionValue.map(backupLoc => [backupLoc.id, backupLoc]));

        case types.BACKUP_LOCATION_ADDITION_UPDATED:
            return (stateValue, actionValue) => newMapWith(stateValue, actionValue.id, actionValue);

        default:
            return null;
    }
};

export default updateableReducer(backupLocationsReducer, initialState.backupLocations);


// WEBPACK FOOTER //
// ./src/js/reducers/backupLocationsReducer.js